(function () {
  if (window.__dvInit) return;
  window.__dvInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('dv-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveals(root) {
    root.querySelectorAll('.dv-reveal:not(.dv-visible)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('dv-visible');
    });
  }

  function initHero(root) {
    root.querySelectorAll('.dv-hero').forEach(function (hero) {
      if (hero.dataset.dvInit) return; hero.dataset.dvInit = '1';
      requestAnimationFrame(function () { hero.classList.add('dv-cargado'); });
      var el = hero.querySelector('.dv-hero__rota');
      if (!el) return;
      var palabras = [];
      try { palabras = JSON.parse(el.getAttribute('data-palabras') || '[]'); } catch (e) {}
      if (palabras.length < 2 || reduce) return;
      var i = 0, pos = palabras[0].length, borrando = true;
      var pausa = parseInt(el.getAttribute('data-pausa') || '2200', 10);
      function tick() {
        var w = palabras[i];
        if (borrando) {
          pos--; el.textContent = w.slice(0, pos);
          if (pos <= 0) { borrando = false; i = (i + 1) % palabras.length; setTimeout(tick, 300); return; }
          setTimeout(tick, 40);
        } else {
          w = palabras[i]; pos++; el.textContent = w.slice(0, pos);
          if (pos >= w.length) { borrando = true; setTimeout(tick, pausa); return; }
          setTimeout(tick, 75);
        }
      }
      setTimeout(tick, pausa);
    });
  }

  function initHotspots(root) {
    root.querySelectorAll('.dv-hs').forEach(function (s) {
      if (s.dataset.dvInit) return; s.dataset.dvInit = '1';
      var puntos = s.querySelectorAll('.dv-hs__punto');
      var items = s.querySelectorAll('.dv-hs__item');
      function activar(n) {
        puntos.forEach(function (p, k) { p.setAttribute('aria-expanded', k === n ? 'true' : 'false'); });
        items.forEach(function (it, k) { it.classList.toggle('dv-activo', k === n); });
      }
      puntos.forEach(function (p, k) { p.addEventListener('click', function () { activar(k); }); p.addEventListener('mouseenter', function () { activar(k); }); });
      items.forEach(function (it, k) { it.addEventListener('click', function () { activar(k); }); it.addEventListener('mouseenter', function () { activar(k); }); });
      activar(0);
    });
  }

  function initColores(root) {
    root.querySelectorAll('.dv-col').forEach(function (s) {
      if (s.dataset.dvInit) return; s.dataset.dvInit = '1';
      var sws = s.querySelectorAll('.dv-col__sw');
      var imgs = s.querySelectorAll('.dv-col__visor img');
      var nombre = s.querySelector('.dv-col__nombre');
      sws.forEach(function (sw, k) {
        sw.addEventListener('click', function () {
          sws.forEach(function (x) { x.classList.remove('dv-activo'); x.setAttribute('aria-pressed', 'false'); });
          sw.classList.add('dv-activo'); sw.setAttribute('aria-pressed', 'true');
          imgs.forEach(function (im, j) { im.classList.toggle('dv-activo', j === k); });
          if (nombre) nombre.textContent = sw.getAttribute('data-nombre');
        });
      });
    });
  }

  function initCifras(root) {
    root.querySelectorAll('.dv-cif__num[data-valor]').forEach(function (el) {
      if (el.dataset.dvInit) return; el.dataset.dvInit = '1';
      var fin = parseFloat(el.getAttribute('data-valor')) || 0;
      var suf = el.getAttribute('data-sufijo') || '';
      if (reduce || !io) { el.textContent = fin + suf; return; }
      el.textContent = '0' + suf;
      var obs = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; obs.disconnect();
        var t0 = null, dur = 1400;
        function paso(t) {
          if (!t0) t0 = t; var p = Math.min((t - t0) / dur, 1);
          var v = Math.round(fin * (1 - Math.pow(1 - p, 3)));
          el.textContent = v + suf; if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      }, { threshold: 0.5 });
      obs.observe(el);
    });
  }

  function initFaq(root) {
    root.querySelectorAll('.dv-faq__item').forEach(function (it) {
      if (it.dataset.dvInit) return; it.dataset.dvInit = '1';
      var b = it.querySelector('.dv-faq__btn');
      b.addEventListener('click', function () {
        var abierto = it.classList.toggle('dv-abierto');
        b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function initProducto(root) {
    root.querySelectorAll('.dv-pr').forEach(function (s) {
      if (s.dataset.dvInit) return; s.dataset.dvInit = '1';
      var principal = s.querySelector('.dv-pr__principal img');
      var minis = s.querySelectorAll('.dv-pr__mini');
      function verFoto(src, mini) {
        if (!principal || !src) return;
        principal.src = src;
        minis.forEach(function (m) { m.classList.toggle('dv-activo', m === mini); });
      }
      minis.forEach(function (m) { m.addEventListener('click', function () { verFoto(m.getAttribute('data-src'), m); }); });

      var datos = s.querySelector('[data-dv-variantes]');
      var variantes = [];
      try { variantes = JSON.parse(datos ? datos.textContent : '[]'); } catch (e) {}
      var selects = s.querySelectorAll('.dv-pr__opcion select');
      var input = s.querySelector('input[name="id"]');
      var precio = s.querySelector('[data-dv-precio]');
      var tachado = s.querySelector('[data-dv-tachado]');
      var boton = s.querySelector('.dv-pr__comprar');
      var txtBoton = boton ? boton.getAttribute('data-texto') : '';
      var txtAgotado = boton ? boton.getAttribute('data-agotado') : '';
      var formato = s.getAttribute('data-moneda') || '{{amount_with_comma_separator}} €';
      function dinero(c) {
        var v = (c / 100).toFixed(2);
        var coma = v.replace('.', ',');
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma).replace(/\{\{\s*amount\s*\}\}/, v);
      }
      function cambio() {
        var elegidas = Array.prototype.map.call(selects, function (x) { return x.value; });
        var v = variantes.find(function (vv) { return vv.options.every(function (o, k) { return o === elegidas[k]; }); });
        if (!v) return;
        if (input) input.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = dinero(v.compare_at_price); tachado.hidden = false; }
          else { tachado.hidden = true; }
        }
        if (boton) {
          boton.disabled = !v.available;
          var span = boton.querySelector('span');
          if (span) span.textContent = v.available ? txtBoton : txtAgotado;
        }
        if (v.featured_image) verFoto(v.featured_image, null);
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u); } catch (e) {}
      }
      selects.forEach(function (x) { x.addEventListener('change', cambio); });
    });
  }

  function initTodo(e) {
    var root = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    initReveals(root); initHero(root); initHotspots(root); initColores(root); initCifras(root); initFaq(root); initProducto(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
